import { HttpErrorResponse } from '@angular/common/http'
import { createAction, props } from '@ngrx/store'
import { AccountInfo, AccountInfoRequest } from '../../models/interfaces/account-info.interface'
import { BasicFile } from '../../models/interfaces/basic-file.interface'
import { BasicItemResult } from '../../models/interfaces/basic-item-result.interface'
import { BasicNotificationsResult, NotificiationNameEnum } from '../../models/interfaces/basic-notifications.interface'
import { User } from '../../models/interfaces/user.interface'

export const setUser = createAction('[stage] Setting user', props<{ user: User }>())

export const setStatuses = createAction('[stage] Setting statuses')

export const setStatusesSuccess = createAction('[stage] Setting statuses SUCCESS', props<{ statuses: BasicItemResult[] }>())

export const setStatusesFailure = createAction('[stage] Setting statuses FAILURE', props<{ error: HttpErrorResponse }>())

export const setVisibilities = createAction('[stage] Setting visibilities')

export const setVisibilitiesSuccess = createAction('[stage] Setting visibilities SUCCESS', props<{ visibilities: BasicItemResult[] }>())

export const setVisibilitiesFailure = createAction('[stage] Setting visibilities FAILURE', props<{ error: HttpErrorResponse }>())

export const setMeasuringPurpose = createAction('[stage] Setting measuring purpose')

export const setMeasuringPurposeSuccess = createAction('[stage] Setting measuring purpose SUCCESS', props<{ measuringPurpose: BasicItemResult[] }>())

export const setMeasuringPurposeFailure = createAction('[stage] Setting measuring purpose FAILURE', props<{ error: HttpErrorResponse }>())

export const setSectors = createAction('[stage] Setting sectors')

export const setSectorsSuccess = createAction('[stage] Setting sectors SUCCESS', props<{ sectors: BasicItemResult[] }>())

export const setSectorsFailure = createAction('[stage] Setting sectors FAILURE', props<{ error: HttpErrorResponse }>())

export const setTechnologies = createAction('[stage] Setting technologies')

export const setTechnologiesSuccess = createAction('[stage] Setting technologies SUCCESS', props<{ technologies: BasicItemResult[] }>())

export const setTechnologiesFailure = createAction('[stage] Setting technologies FAILURE', props<{ error: HttpErrorResponse }>())

export const setCountries = createAction('[stage] Setting countries')

export const setCountriesSuccess = createAction('[stage] Setting countries SUCCESS', props<{ countries: BasicItemResult[] }>())

export const setCountriesFailure = createAction('[stage] Setting countries FAILURE', props<{ error: HttpErrorResponse }>())

export const setPNOCountryResponsibles = createAction('[stage] Setting PNO country responsibles')

export const setPNOCountryResponsiblesSuccess = createAction(
   '[stage] Setting PNO country responsibles SUCCESS',
   props<{ pnoCountryResponsibles: BasicItemResult[] }>()
)
export const setPNOCountryResponsiblesFailure = createAction('[stage] Setting PNO country responsibles FAILURE', props<{ error: HttpErrorResponse }>())

export const deleteProject = createAction('[stage] Deleting project', props<{ id: number; status: number }>())

export const deleteProjectSuccess = createAction('[stage] Deleting project SUCCESS')

export const deleteProjectFailure = createAction('[stage] Deleting project FAILURE', props<{ error: HttpErrorResponse }>())

export const changePassword = createAction('[stage] Changing password', props<{ request: { oldPassword: string; newPassword: string } }>())

export const changePasswordSuccess = createAction('[stage] Changing password SUCCESS')

export const changePasswordFailure = createAction('[stage] Changing password FAILURE', props<{ error: HttpErrorResponse }>())

export const getAccountInfo = createAction('[stage] Getting account info')

export const getAccountInfoSuccess = createAction('[stage] Getting account info SUCCESS', props<{ accountInfo: AccountInfo }>())

export const getAccountInfoFailure = createAction('[stage] Getting account info FAILURE', props<{ error: HttpErrorResponse }>())

export const updateAccountInfo = createAction('[stage] Updating account info', props<{ accountInfo: AccountInfoRequest }>())

export const updateAccountInfoSuccess = createAction('[stage] Updating account info SUCCESS')

export const updateAccountInfoFailure = createAction('[stage] Updating account info FAILURE', props<{ error: HttpErrorResponse }>())

export const deleteAvatar = createAction('[stage] Deleting avatar')

export const deleteAvatarSuccess = createAction('[stage] Deleting avatar SUCCESS')

export const deleteAvatarFailure = createAction('[stage] Deleting avatar FAILURE', props<{ error: HttpErrorResponse }>())

export const getAvatar = createAction('[stage] Getting avatar')

export const getAvatarSuccess = createAction('[stage] Getting avatar SUCCESS', props<{ avatarFile: BasicFile }>())

export const getAvatarFailure = createAction('[stage] Getting avatar FAILURE', props<{ error: HttpErrorResponse }>())

export const updateAvatar = createAction('[stage] Updating avatar', props<{ file: BasicFile }>())

export const updateAvatarSuccess = createAction('[stage] Updating avatar SUCCESS')

export const updateAvatarFailure = createAction('[stage] Updating avatar FAILURE', props<{ error: HttpErrorResponse }>())

export const setPathLocationPrevious = createAction('[stage] Setting location previous', props<{ pathLocationPrevious: string }>())

export const getPNOUserNotifications = createAction('[stage] Getting PNO user notifications')

export const getPNOUserNotificationsSuccess = createAction(
   '[stage] Getting PNO user notifications SUCCESS',
   props<{ userNotifications: BasicNotificationsResult }>()
)

export const getPNOUserNotificationsFailure = createAction('[stage] Getting PNO user notifications FAILURE', props<{ error: HttpErrorResponse }>())

export const updatePNOUserNotifications = createAction(
   '[stage] Updating PNO user notifications',
   props<{ notificationName: NotificiationNameEnum; isActive: boolean }>()
)

export const updatePNOUserNotificationsSuccess = createAction('[stage] Updating PNO user notifications SUCCESS')

export const updatePNOUserNotificationsFailure = createAction('[stage] Updating PNO user notifications FAILURE', props<{ error: HttpErrorResponse }>())

export const retryConnectionStarted = createAction('[stage] Retry connection STARTED')

export const retryConnectionSuccess = createAction('[stage] Retry connection SUCCESS')

export const retryConnectionFailure = createAction('[stage] Retry connection FAILURE')

export const cleanNotifications = createAction('[stage] Cleaning notifications')
